
const constants = {
  API_MESSAGES: {
    NO_ACTIVE_DRIVERS: "No Active Drivers found",
    NO_RECOMMENDATION_AVAILABLE: "No Recommendations available",
    RECOMMENDATION_FAILED: "Driver Recommendations failed",
    NO_FEASIBLE_DRIVERS: "No Feasible driver available",
    FAILED_TO_FETCH: 'Please retry, Failed to load recommendation data',
    FETCH_IN_PROGRESS: 'Loading recommendations, please wait...',
    REFRESH_RECOMMENDATION: 'Refresh recommendations',
    LOADING_DRIVER_KPI: 'Fetching driver KPI data...',
  },
  RECOMMENDATION_BUTTON_LABEL: {
    ASSIGN: 'Assign',
    PREVIEW: 'Preview'
  },
  MAP_HEADER: {
    BeforePickupAssignment: {
      MAP_ID: 'beforePickupAssignment',
      MAP_HEADER_LABEL: 'Before pickup assignment'
    },
    AfterPickupAssignment: {
      MAP_ID: 'afterPickupAssignment',
      MAP_HEADER_LABEL: 'After pickup assignment'
    }
  },
  RECOMMENDATION_DIALOG_TRANSITION_TIMEOUT : 500,
};

export default constants;
